import React from 'react';

const Footer = () => {
  return (
    <footer className="border-t border-[#333] pt-20 pb-10 px-4 sm:px-6 lg:px-8 bg-black">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-end gap-10">
        <div>
          <h2 className="text-5xl sm:text-7xl font-black tracking-tighter uppercase mb-4">
            Slate<span className="text-acid">Run</span>
          </h2>
          <p className="text-[#737373] text-sm uppercase font-bold tracking-widest max-w-xs">
            Engineered footwear for the concrete jungle. Limited quantities. Zero compromises.
          </p>
        </div>
        
        <div className="flex flex-col items-end gap-2 text-right">
          <a href="#" className="text-[#737373] hover:text-white uppercase text-xs font-bold tracking-widest">Instagram</a>
          <a href="#" className="text-[#737373] hover:text-white uppercase text-xs font-bold tracking-widest">Twitter / X</a>
          <a href="#" className="text-[#737373] hover:text-white uppercase text-xs font-bold tracking-widest">Contact</a>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto mt-20 pt-8 border-t border-[#222] flex flex-col sm:flex-row justify-between items-center gap-4 text-xs font-mono text-[#555]">
        <p>© {new Date().getFullYear()} SLATERUN SNEAKERS. ALL RIGHTS RESERVED.</p>
        <p className="text-acid">Made by LingLink AI and DigLab AI</p>
      </div>
    </footer>
  );
};

export default Footer;